const funcs = {
  getUser(state) {
    return state.user;
  }
};

export default funcs;
